import { createAsyncThunk} from '@reduxjs/toolkit'
import { checkToken } from '../misc/utils'



export const getAllUsers =  createAsyncThunk('getAllUsers', async (_, store) => {
	const token = await checkToken(store)

	const response = await fetch(`${process.env.REACT_APP_ENV === 'dev' ? process.env.REACT_APP_LOCAL_API_URL : process.env.REACT_APP_API_URL}/admin/users`, {
		method: 'GET',
		credentials: 'include',
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json'
		},
	})

	return response.json()
})
